export default __webpack_public_path__ + "static/media/tiffany.a8444bfd.jpg";